// src/features/auth/utils/errorMapper.ts
import { SignupFormData } from "../types/authTypes";

type FieldKey = keyof SignupFormData;

/**
 * Maps API error messages to SignupFormData field keys + friendly messages.
 */
export const mapApiErrorToField = (
  errorMessage: string
): { field: FieldKey; message: string } | null => {
  const mapping: Record<string, { field: FieldKey; message: string }> = {
    "Username Already Exists": {
      field: "user_name",
      message: "Username already exists.",
    },
    "Organization name Already Exists": {
      field: "organization_name",
      message: "Organization name already exists",
    },
    "Organization name already exists": {
      field: "organization_name",
      message: "Organization name already exists",
    },
    "Email Already Exists": {
      field: "email_id",
      message: "Email already exists",
    },
    "Phone Number Already Exists": {
      field: "phone_number",
      message: "Phone number already exists",
    },
  };

  return mapping[errorMessage] || null;
};
